import { useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { PrivateResearchItem } from './types';

interface UsePrivateResearchNavigationProps {
  allResearch: PrivateResearchItem[];
  isLightboxOpen: boolean;
  onResearchClick: (research: PrivateResearchItem) => void;
}

export const usePrivateResearchNavigation = ({
  allResearch,
  isLightboxOpen,
  onResearchClick,
}: UsePrivateResearchNavigationProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Enhanced close handler that clears URL parameter
  const handleCloseLightboxWithUrlCleanup = useCallback(() => {
    console.log('[PrivateResearchNavigation] Closing lightbox and clearing URL parameter');
    
    // Clear the research parameter from URL
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('research')) {
      searchParams.delete('research');
      const newUrl = searchParams.toString() 
        ? `${location.pathname}?${searchParams.toString()}`
        : location.pathname;
      navigate(newUrl, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  // URL Parameter Handling - Auto-open lightbox for specific research
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const researchId = searchParams.get('research');
    
    if (researchId && !isLightboxOpen) {
      console.log('[PrivateResearchNavigation] URL research parameter detected:', researchId);
      
      if (allResearch.length > 0) {
        const targetResearch = allResearch.find(research => research.id === researchId);
        
        if (targetResearch) {
          console.log('[PrivateResearchNavigation] Opening lightbox for research:', targetResearch.title);
          onResearchClick(targetResearch);
        }
      }
    }
  }, [location.search, isLightboxOpen, allResearch, onResearchClick]);

  return {
    handleCloseLightboxWithUrlCleanup,
  };
}; 